var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBing(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 234 343.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), /*#__PURE__*/React.createElement("defs", null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: -29.25,
    y1: 662.02,
    x2: -23.09,
    y2: 658.46,
    gradientTransform: "matrix(24.45, 0, 0, -24.45, 967.18, 16420.97)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#37bdff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#33bffd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#28c5f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#15d0e9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#12d1e7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#1cd2e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#42d8dc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#59dbd6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62dcd4"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: -32.86,
    y1: 656.68,
    x2: -23.89,
    y2: 656.68,
    gradientTransform: "matrix(24.45, 0, 0, -24.45, 967.18, 16420.97)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#39d2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#38cefe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#35c3fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#2fb0f3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#299aeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#2692ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#1a6cf1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1355f4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#104cf5"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: -31.2,
    y1: 655.9,
    x2: -31.2,
    y2: 667.89,
    gradientTransform: "matrix(24.45, 0, 0, -24.45, 967.18, 16420.97)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1b48ef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#1c51f0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#1e69f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#2190fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#26b8f4"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "d",
    transform: "translate(-163 -82.94)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 163.02,
    y: 288.38,
    width: 227.17,
    height: 140.76,
    style: {
      fill: "none"
    }
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: -31.08,
    y1: 654.47,
    x2: -25.54,
    y2: 660,
    gradientTransform: "matrix(24.45, 0, 0, -24.45, 967.18, 16420.97)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#f6f6f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#ebebeb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#dadada"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#a8a8a8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#888"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#626262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#373737"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#090909"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "f",
    transform: "translate(-163 -82.94)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 163.02,
    y: 82.87,
    width: 86.51,
    height: 302.96,
    style: {
      fill: "none"
    }
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: -31.2,
    y1: 668.1,
    x2: -31.2,
    y2: 656.02,
    xlinkHref: "#e"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "bing-logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M397,303.4a92.73,92.73,0,0,1-24.84,63.16,41.81,41.81,0,0,0,4.5-6,38.11,38.11,0,0,0,2.69-5.08,17.7,17.7,0,0,0,.74-1.78,17.25,17.25,0,0,0,.65-1.78c.21-.56.39-1.14.55-1.72s.33-1.2.46-1.81l.07-.21c.14-.6.25-1.2.37-1.81s.23-1.25.33-1.88v0c.09-.58.16-1.16.21-1.76a40,40,0,0,0,.21-4.13A41.41,41.41,0,0,0,377,317.11a36.51,36.51,0,0,0-2.85-4.17,39.93,39.93,0,0,0-4-4.43,41.45,41.45,0,0,0-12.36-8.28,38.78,38.78,0,0,0-6.22-2.14l-.09,0-.74-.25-10.81-3.71v0l-28.27-9.72c-.09,0-.21,0-.28,0l-1.77-.65A26.23,26.23,0,0,1,296.29,272L286,245.62l-11.83-30.16-2.27-5.82-.58-1.18a13.35,13.35,0,0,1-1-5.08,12,12,0,0,1,0-1.35,13.19,13.19,0,0,1,18.26-10.79l52.69,27,10.39,5.31A91.11,91.11,0,0,1,367,235a92.45,92.45,0,0,1,29.79,61.87C396.91,299.06,397,301.22,397,303.4Z",
    transform: "translate(-163 -82.94)",
    style: {
      fill: "url(#a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382.91,338.56a42.8,42.8,0,0,1-.72,7.82c-.14.67-.28,1.35-.44,2-.3,1.2-.62,2.36-1,3.53-.21.6-.42,1.2-.65,1.78s-.49,1.18-.74,1.78a38.1,38.1,0,0,1-2.69,5.08,42.22,42.22,0,0,1-4.5,6c-7.68,8.49-33.75,23.63-43.36,29.79l-21.33,13c-15.63,9.63-30.41,16.45-49,16.91-.88,0-1.74,0-2.6,0-1.2,0-2.39,0-3.57-.07a92.86,92.86,0,0,1-74.92-43.17,91.58,91.58,0,0,1-13.68-38.67,41.13,41.13,0,0,0,60,28.95l.14-.07,2.09-1.25,8.49-5,10.81-6.4v-.3l1.39-.83,96.71-57.29,7.44-4.41.74.25.09,0a38.31,38.31,0,0,1,6.22,2.14,41.45,41.45,0,0,1,12.36,8.28,40,40,0,0,1,4,4.43,37,37,0,0,1,2.85,4.17A41.64,41.64,0,0,1,382.91,338.56Z",
    transform: "translate(-163 -82.94)",
    style: {
      fill: "url(#b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.24,147.35l0,213.29L234.39,367l-8.5,5-2.09,1.27a.24.24,0,0,0-.13.06,41.13,41.13,0,0,1-60-28.94c-.16-.89-.28-1.81-.38-2.7-.13-1.68-.22-3.33-.25-5v-240a13.77,13.77,0,0,1,21.46-11.41l42.07,27.48a5.55,5.55,0,0,0,.73.51A41.14,41.14,0,0,1,245.24,147.35Z",
    transform: "translate(-163 -82.94)",
    style: {
      fill: "url(#c)"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.14900000393390656,
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#d)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M382.91,338.56a42.8,42.8,0,0,1-.72,7.82c-.14.67-.28,1.35-.44,2-.3,1.2-.62,2.36-1,3.53-.21.6-.42,1.2-.65,1.78s-.49,1.18-.74,1.78a38.1,38.1,0,0,1-2.69,5.08,41.81,41.81,0,0,1-4.5,6c-7.68,8.49-33.75,23.63-43.36,29.79l-21.33,13c-15.63,9.63-30.41,16.45-49,16.91-.88,0-1.74,0-2.6,0-1.2,0-2.39,0-3.57-.07a92.86,92.86,0,0,1-74.92-43.17,91.58,91.58,0,0,1-13.68-38.67,41.13,41.13,0,0,0,60,28.95l.14-.07,2.09-1.25,8.49-5,10.81-6.4v-.3l1.39-.83,96.71-57.29,7.44-4.41.74.25.09,0a38.31,38.31,0,0,1,6.22,2.14,41.45,41.45,0,0,1,12.36,8.28,40,40,0,0,1,4,4.43,37,37,0,0,1,2.85,4.17A41.64,41.64,0,0,1,382.91,338.56Z",
    transform: "translate(-163 -82.94)",
    style: {
      fill: "url(#e)"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.09799999743700027,
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#f)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M245.24,147.35l0,213.29L234.39,367l-8.5,5-2.09,1.27a.24.24,0,0,0-.13.06,41.13,41.13,0,0,1-60-28.94c-.16-.89-.28-1.81-.38-2.7-.13-1.68-.22-3.33-.25-5v-240a13.77,13.77,0,0,1,21.46-11.41l42.07,27.48a5.55,5.55,0,0,0,.73.51A41.14,41.14,0,0,1,245.24,147.35Z",
    transform: "translate(-163 -82.94)",
    style: {
      fill: "url(#g)"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBing);
export default __webpack_public_path__ + "static/media/bing.1f5d73cd02417e427a4621659952b10f.svg";
export { ForwardRef as ReactComponent };